import { createContext, ReactNode, useContext, useEffect, useState } from "react"

const CmdPressedContext = createContext<boolean>(false)

// Isolated provider for the "cmd/ctrl pressed" flag. Keeping it out of
// MainContext means a keypress only re-renders the components that read it
// (list rows that switch to multi-select), not the whole app.
const CmdPressedProvider = ({ children }: { children: ReactNode }) => {
  const [cmdPressed, setCmdPressed] = useState<boolean>(false)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Meta") {
        setCmdPressed(true)
      }
    }
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === "Meta") {
        setCmdPressed(false)
      }
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        setCmdPressed(false)
      }
    }

    document.addEventListener("keydown", handleKeyDown)
    document.addEventListener("keyup", handleKeyUp)
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.removeEventListener("keyup", handleKeyUp)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  return (
    <CmdPressedContext.Provider value={cmdPressed}>
      {children}
    </CmdPressedContext.Provider>
  )
}

const useCmdPressed = () => useContext(CmdPressedContext)

export { CmdPressedProvider, CmdPressedContext, useCmdPressed }
